import React from 'react';
import { Check } from 'lucide-react';

/**
 * Indicador de etapas do wizard de cadastro.
 * Cada bolinha é clicável (permite voltar/pular etapas via onStepClick).
 * Scroll horizontal em mobile para não quebrar layout com muitos passos.
 */
export default function StepIndicator({ currentStep, totalSteps, stepLabels, onStepClick }) {
  return (
    <div className="mb-8">
      <div className="overflow-x-auto pb-2 -mx-4 px-4">
        <div className="flex items-center min-w-max">
          {Array.from({ length: totalSteps }, (_, i) => (
            <React.Fragment key={i}>
              <div className="flex flex-col items-center flex-shrink-0">
                <button
                  type="button"
                  onClick={() => onStepClick && onStepClick(i + 1)}
                  className={`w-9 h-9 md:w-10 md:h-10 rounded-full flex items-center justify-center font-bold text-sm transition-all cursor-pointer hover:scale-110 ${
                    i + 1 <= currentStep
                      ? 'bg-[var(--primary)] text-white'
                      : 'bg-gray-200 text-gray-500 hover:bg-gray-300'
                  }`}
                  data-testid={`step-${i + 1}`}
                >
                  {i + 1 <= currentStep - 1 ? <Check className="w-4 h-4 md:w-5 md:h-5" /> : i + 1}
                </button>
                <span className="text-[10px] md:text-xs mt-1 text-center w-16 md:w-20 truncate text-[var(--text-secondary)]">
                  {stepLabels[i]}
                </span>
              </div>
              {i < totalSteps - 1 && (
                <div
                  className={`w-4 md:w-6 h-0.5 mx-0.5 md:mx-1 rounded flex-shrink-0 ${
                    i + 1 < currentStep ? 'bg-[var(--primary)]' : 'bg-gray-200'
                  }`}
                />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}
